<template>
  <div>
    <p class="m-tb-md">
      <router-link to="/loan-officers">loan-officers/</router-link>
      {{ getActive.display_name }}
    </p>
    <div class="tile--grid">
      <AdminBlock :active="getActive" />
      <ContactBlock :active="getActive" />
      <Manager :manager="getActive.manager" />
      <ListedLocations :active="getActive" />
    </div>
    <States :active="getActive" />
    <LicensedLocations :active="getActive" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AdminBlock from "./Admin-Block";
import ContactBlock from "./Contact-Block";
import States from "./States";
import Manager from "./Manager";
import ListedLocations from "./Locations-Listed";
import LicensedLocations from "./Locations-Licensed";

export default {
  components: {
    AdminBlock,
    ContactBlock,
    States,
    Manager,
    ListedLocations,
    LicensedLocations
  },
  data() {
    return {
      form: {
        removal: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      getActive: "loanOfficers/getActive"
    })
  }
};
</script>

<style scoped lang="scss">
@media (min-width: $md) {
  .tile--grid {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
  }
}
</style>